import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";

import {
  Modal,
  Row,
  Col,
  Nav,
  Form,
  Button,
  Alert,
  Container,
} from "react-bootstrap";

export default class TermsAndConditions extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  getTermsAndConditions = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetTermsAndConditionsHtml/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          var d1 = document.getElementById("one");
          if (d1) {
            d1.innerHTML = data;
          }
        }
      })
      .catch((error) => {
        console.error("getTermsAndConditions!", error);
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getTermsAndConditions();
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
  };

  render() {
    return (
      <>
        <>
          <div className="Container-fluid mx-0 px-1 ">
            <div className="row mt-2 mx-1 px-0">
              <div className="col-md-1 "></div>
              <div className="col-md-10  ">
                <>
                  <br></br>
                  <h3 className="">
                    <b></b>
                  </h3>
                  <br></br>
                  <h5>
                    <div id="one"></div>
                  </h5>
                </>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}

export class PrivacyPolicy extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  getPrivacyPolicy = () => {
    fetch(process.env.REACT_APP_API + "Sales/GetPrivacyPolicyHtml/")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          var d1 = document.getElementById("one");
          if (d1) {
            d1.innerHTML = data;
          }
        }
      })
      .catch((error) => {
        console.error("getPrivacyPolicy!", error);
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getPrivacyPolicy();
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
  };

  render() {
    return (
      <>
        <>
          <div className="Container-fluid mx-0 px-1 ">
            <div className="row mt-2 mx-1 px-0">
              <div className="col-md-1 "></div>
              <div className="col-md-10  ">
                <>
                  <br></br>
                  <h3 className="">
                    <b></b>
                  </h3>
                  <br></br>
                  <h5>
                    <div id="one"></div>
                  </h5>
                </>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}

// export class Faqs extends Component {
//   static contextType = CartContext;
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   getFaqs = () => {
//     fetch(
//       process.env.REACT_APP_API +
//         "Consumers/GetFaqsHtml/" +
//         this.context.storeId
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status == 400) {
//         } else {
//           var d1 = document.getElementById("one");
//           if (d1) {
//             d1.innerHTML = data;
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("getFaqs!", error);
//       });
//   };

//   GetMyStoreDetails = () => {
//     var v1 = process.env.REACT_APP_API + "Consumers/GetMyStoreDetails/";
//     fetch(process.env.REACT_APP_API + "Consumers/GetMyStoreDetails/")
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status == 400) {
//         } else {
//           this.context.setStoreId(data.id);
//           this.getFaqs();
//         }
//       })
//       .catch((error) => {});
//   };
//   componentDidMount() {
//     window.scrollTo(0, 0);
//     this.context.SetHomePageLoadedStatus();
//     if (this.context.storeId == "") {
//       this.GetMyStoreDetails();
//     } else {
//       this.getFaqs();
//     }
//   }

//   handleSubmit = (event) => {
//     const form = event.currentTarget;
//     event.preventDefault();
//   };

//   render() {
//     return (
//       <>
//         <>
//           <div className="Container-fluid mx-0 px-1 ">
//             <div className="row mt-2 mx-1 px-0">
//               <div className="col-md-1 "></div>
//               <div className="col-md-10  ">
//                 <>
//                   <br></br>
//                   <h3 className="">
//                     <b></b>
//                   </h3>
//                   <br></br>
//                   <h5>
//                     <div id="one"></div>
//                   </h5>
//                 </>
//               </div>
//             </div>
//           </div>
//         </>
//       </>
//     );
//   }
// }

export class ContactUs extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      xmlString:
        "<html>Please Calll or WhatsApp to <a href='https://wa.me/919880582728' target='_blank'>+91 9880582728</a> for Queries, Feedbacks and Complaints</html>",
      printed: false,
    };
  }

  componentDidMount() {
    if (this.state.printed == false) {
      var d1 = document.getElementById("one");
      if (d1) d1.innerHTML = this.state.xmlString;
      this.setState({ printed: true });
    }
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
  };

  render() {
    return (
      <>
        <>
          <div className="mx-0 px-1 " style={{ paddingTop: "65px" }}>
            <div className="row mt-2 mx-1 px-0">
              <div className="col-md-1 "></div>
              <div className="col-md-10  ">
                <>
                  <br></br>
                  <h3 className="">
                    <b>Contact us</b>
                  </h3>
                  <br></br>
                  <h5>
                    <div id="one"></div>
                  </h5>
                </>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}
